export default "__VITE_ASSET__681ac502__"